import React, { PropsWithChildren, ReactElement } from 'react'
import { Breakpoint, useMediaQuery } from '@mui/material'

interface Props extends PropsWithChildren {
  down: Breakpoint
}

export const Hidden: React.FC<Props> = ({ down, children }): ReactElement => {
  const hidden = useMediaQuery((theme) => theme.breakpoints.down(down))
  return hidden ? <></> : <>{children}</>
}
